import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "text",
  "use": "text-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" fill=\"currentColor\" id=\"text\"><path d=\"M9 6L2 26h2l2.12-6h7.76L16 26h2L11 6zM6.82 18L10 9l3.18 9zM29 24a1 1 0 01-1-1v-9h-2v.76a4.5 4.5 0 00-7 3.74v3a4.51 4.51 0 004.5 4.5 4.46 4.46 0 003.08-1.24A3 3 0 0029 26h1v-2zm-5.5 0a2.5 2.5 0 01-2.5-2.5v-3a2.5 2.5 0 015 0v3a2.5 2.5 0 01-2.5 2.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/text.svg
// module id = Vhpx
// module chunks = 39 44